var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"olb-econ-wrapper"},[(_vm.liveUrl)?_c('iframe',{ref:"econFrame",staticClass:"w-full",attrs:{"src":_vm.liveUrl,"title":"ECON Frame"}}):_c('p',{staticClass:"p-4 text-red"},[_vm._v(_vm._s(_vm.errorText))])])}
var staticRenderFns = []

export { render, staticRenderFns }